$(function(){
  swipers();
  scrollButton();
  locator();
  mobileMenu();
  viewMore();
  registerForm();
  invoiceForm();
  clerkClose();
  menu();
  passwordHide();
  drawer();
});

const TOKEN = '661e224da7bd961c9a0dfe89';
const VATURL = 'https://company.openapi.com/EU-start/';
const VATS = {
  AT: /U[0-9]{8}$/i,
  BE: /0[0-9]{9}$/i,
  BG: /[0-9]{9,10}$/i,
  CY: /^\d{8}[A-Za-z]$/i,
  CZ: /[0-9]{8,10}$/i,
  DE: /[0-9]{9}$/i,
  DK: /[0-9]{8}$/i,
  EE: /[0-9]{9}$/i,
  EL: /[0-9]{9}$/i, 
  GR: /[0-9]{9}$/i, 
  ES: /[0-9A-Z][0-9]{7}[0-9A-Z]$/i,
  FI: /[0-9]{8}$/i,
  FR: /[0-9A-Z]{2}[0-9]{9}$/i,
  GB: /([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})$/i,
  HU: /[0-9]{8}$/i,
  IE: /^[0-9]{7}[A-Z]{1,2}$/i,
  IT: /[0-9]{11}$/i,
  LT: /([0-9]{9}|[0-9]{12})$/i,
  LU: /[0-9]{8}$/i,
  LV: /[0-9]{11}$/i,
  MT: /[0-9]{8}$/i,
  NL: /[0-9]{9}B[0-9]{2}$/i,
  PL: /[0-9]{10}$/i,
  PT: /[0-9]{9}$/i,
  RO: /[0-9]{2,10}$/i,
  SE: /[0-9]{12}$/i,
  SI: /[0-9]{8}$/i,
  SK: /[0-9]{10}$/i,
};

function clerkClose(){
  $('.btn-close-clerk').on('click', function(){
    $('.site-header__search-container').removeClass('is-active');
  });
}

function swipers(){
  $('[data-swiper]').each(function(){
    var opt = {
      autoHeight: false,
      spaceBetween: parseInt($(this).attr('data-swiper-margin')) > 0 ? parseInt($(this).attr('data-swiper-margin')) : 0
    };
    if($(this).attr('data-swiper-pagination') != undefined){
      opt.pagination = {
        el: ".swiper-pagination",
        draggable: true,
        dynamicBullets: true,
        clickable: true
      };
    }
    if($(this).attr('data-swiper-navigation') != undefined){
      opt.navigation = {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      };
    }
    if($(this).attr('data-swiper-scrollbar') != undefined){
      opt.scrollbar = {
        el: ".swiper-scrollbar",
        draggable: true,
        hide: true
      };
    }
    if(parseInt($(this).attr('data-swiper-autoplay')) > 0){
      opt.autoplay = {
        delay: $(this).attr('data-swiper-autoplay'),
        disableOnInteraction: false,
      };
    }
    if($(this).attr('data-swiper-autowidth') != undefined){
      opt.slidesPerView = "auto";
    } else if($(this).attr('data-swiper-breakpoints') != undefined){
      var points = $(this).attr('data-swiper-breakpoints').split(',');
      opt.breakpoints = {};
      $(points).each(function(){
        var els = this.split(':');
        if(els[0].localeCompare('default') == 0){
          opt.slidesPerView = els[1];
        } else {
          opt.breakpoints[els[0]] = {
            slidesPerView: els[1]
          }
        }
      });
    }
    try{
      var swiper = new Swiper(this, opt);
    } catch(e){
      console.log(e);
      console.log('error with swiper');
    }
  });
}

function scrollButton(){
  if($('#btn-scroll').length){
    var mybutton = document.getElementById('btn-scroll');
    
    window.onscroll = function () {
      scrollFunction(mybutton);
    };

  }
  
  function scrollFunction(mybutton) {
    if (document.body.scrollTop > 900 || document.documentElement.scrollTop > 900) {
      mybutton.style.display = 'flex';
    } else {
      mybutton.style.display = 'none';
    }
  }
}

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
  jQuery('html, body').animate({ scrollTop: 0 });
}

function locator(){
  var filtered = [];
  if($('#map').length){
    var lat = Number($('#map').attr('data-latitude'));
    var long = Number($('#map').attr('data-longitude'));
    var zoom = parseInt($('#map').attr('data-zoom'));
    var map = new google.maps.Map(document.getElementById("map"), {
      center: { lat: lat, lng: long },
      mapTypeId: 'roadmap',
      zoom: zoom,
    });
    var infowindow = new google.maps.InfoWindow();
    
    var sCountries = [];
    var sCities = [];
    
    for(var i=0;i<stores.length;i++){
      var latLng = new google.maps.LatLng(stores[i].latitude, stores[i].longitude);
      var marker = new google.maps.Marker({
        position: latLng,
        map: map,
        title: stores[i].title,
        optimized: true,
        url: stores[i].link
      });
      google.maps.event.addListener(marker, 'click', (function(marker, i) {
        return function() {
            infowindow.setContent(`<a href="${stores[i].link}">${stores[i].title}<br>${stores[i].address}<br>${stores[i].zip} ${stores[i].city}<br>${stores[i].paese}<br><br><u>Details</u></a>`);
            infowindow.open(map, marker);
        }
      })(marker, i));
      stores[i].marker = marker;
    }

    $('[data-locator-filter]').on('change', function(){
      filterStores($(this).attr('data-locator-filter'), $(this).val());
    });
  }

  function filterStores(type){
    var selected = $('[data-locator-filter="'+type+'"]:checked');
    var filters = [];
    $(selected).each(function(){
      filters.push($(this).val());
    });
    if(type == 'country')
      sCountries = filters;
    else if(type == 'city')
      sCities = filters;

    $(stores).each(function(){
      var show = (sCountries.length == 0 || inArray(this.paese, sCountries)) && (sCities.length == 0 || inArray(this.city, sCities));
      const store = $('[data-store-id="'+this.id+'"]');
      if(show){
        this.marker.setMap(map);
        map.setCenter(this.marker.getPosition());
        $(store).removeClass('d-none');
      } else {
        this.marker.setMap(null);
        $(store).addClass('d-none');
      }
    });
  }
}
function inArray(needle, haystack) {
  var length = haystack.length;
  for(var i = 0; i < length; i++) {
      if(haystack[i] == needle || haystack[i].localeCompare(needle) === 0) return true;
  }
  return false;
}

function mobileMenu(){
  $('[data-accordion]').on('click', function(){
    var accordion = $(this).attr('data-accordion');
    $('.accordion').removeClass('open');
    $(accordion).addClass('open');
  });

  $('.mobile-nav-trigger').on('click', function(e){
    e.preventDefault();
    $('#mobile-menu').addClass('open');
  });
  $('[data-menu-close]').on('click', function(e){
    e.preventDefault();
    $('#mobile-menu').removeClass('open');
  });
}

function invoiceForm(){
  var checkVat = false;
  var checkPec = false;
  const eu = ['AT', 'BE', 'BG', 'CY', 'HR', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'IE', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'CZ', 'RO', 'SK', 'SI', 'ES', 'SE', 'HU', 'IT'];

  const s = {
    inputCountry: '#invoice-form #invoice-country',
    inputCompany: '#invoice-form #invoice-company',
    inputVat: '#invoice-form #invoice-vat',
    inputPec: '#invoice-form #invoice-pec',
    inputSdi: '#invoice-form #invoice-sdi',
    inputs: '#invoice-form [data-invoice-input]',
    sdiPec: '#invoice-form [data-optional]',
    submit: '#invoice-form #invoice-submit',
    form: '#invoice-form'
  }

  checkCountry();
  $(s.submit).on('click', function(){
    var validCompany = validateCompany();
    var validVat = validateVat();
    var validPec = validatePec();
    var validSdi = validateSdi();
    if(validCompany && validVat && validPec && validSdi){
      controlVat();
    }
  });

  $(s.inputCountry).on('change', function(){
    checkCountry();
  });

  $(s.inputSdi).on('blur', function(){
    setUppercase(this);
  });

  $(s.inputs).on('focus', function(){
    var error = $(this).parent().find('[data-error]');
    $(this).removeClass('is-error');
    $(error).text('');
  });
  $(s.inputSdi).on('keyup', function(){
    disableInput();
  });

  $(s.inputPec).on('keyup', function(){
    disableInput();
  });

  function disableInput() {
    if($(s.inputPec).val().length > 0){
      $(s.inputSdi).prop('disabled', true);
      $(s.inputSdi).val('');
      $(s.inputPec).prop('disabled', false);
    } else if($(s.inputSdi).val().length > 0){
      $(s.inputSdi).prop('disabled', false);
      $(s.inputPec).val('');
      $(s.inputPec).prop('disabled', true);
    } else {
      $(s.inputSdi).prop('disabled', false);
      $(s.inputPec).prop('disabled', false);
    }
  }

  function validateCompany(){
    var input = s.inputCompany;
    var val = $(input).val();
    var error = $(input).parent().find('[data-error]');
    var valid = val != undefined && val.length > 0;
    if(valid){
      $(input).removeClass('is-error');
      $(error).text('');
    } else {
      $(input).addClass('is-error');
      $(error).text(invoice_errors.required);
    }
    return valid;
  }

  function validateVat(){
    var input = s.inputVat;
    var val = $(input).val();
    var error = $(input).parent().find('[data-error]');
    var valid = val != undefined && val.length > 0;
    if(valid){
      var r = VATS[$(s.inputCountry).val()];
      if(r != undefined){
        valid = r.test(val);
        if(valid){
          $(input).removeClass('is-error');
          $(error).text('');
        } else {
          $(input).addClass('is-error');
          $(error).text(invoice_errors.vat);
        }
      }
    } else {
      $(input).addClass('is-error');
      $(error).text(invoice_errors.required);
    }
    return valid;
  }

  function validatePec(){
    var input = s.inputPec;
    var val = $(input).val();
    var sdi = $(s.inputSdi).val();
    var error = $(input).parent().find('[data-error]');
    var valid = checkPec ? ((val != undefined && val.length > 0) || (sdi != undefined && sdi.length > 0)) : true;
    var msg = invoice_errors.required_pec;
    if(valid && checkPec && (sdi == undefined || sdi.length <= 0)){
      valid = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(val);
      msg = invoice_errors.email;
    }
    if(valid){
      $(input).removeClass('is-error');
      $(error).text('');
    } else {
      $(input).addClass('is-error');
      $(error).text(msg);
    }
    return valid;
  }

  function validateSdi(){
    var input = s.inputSdi;
    var val = $(input).val();
    var pec = $(s.inputPec).val();
    var error = $(input).parent().find('[data-error]');
    var valid = checkPec ? ((val != undefined && val.length > 0) || (pec != undefined && pec.length > 0)) : true;
    var msg = invoice_errors.required_pec;
    if(valid && checkPec && (pec == undefined || pec.length <= 0)){
      valid = /^[0-9a-zA-Z]{7}$/gm.test(val);
      msg = invoice_errors.sdi;
    }
    if(valid){
      $(input).removeClass('is-error');
      $(error).text('');
    } else {
      $(input).addClass('is-error');
      $(error).text(msg);
    }
    return valid;
  }

  function checkCountry(){
    var country = $(s.inputCountry).val();
    
    if(country == 'IT'){
      checkPec = true;
    } else {
      checkPec = false;
    }

    if(eu.indexOf(country) != -1){
      checkVat = true;
    } else {
      checkVat = false;
    }

    if(checkPec){
      $(s.sdiPec).removeClass('hide');
    } else {
      $(s.sdiPec).first().addClass('hide');
    }
  }

  function controlVat(){
    Swal.fire({
      title: progress_msg.title,
      html: progress_msg.description,
      icon: undefined,
      showConfirmButton: false
    });
    if(checkVat){
      var input = s.inputVat;
      var error = $(input).parent().find('[data-error]');
      $.ajax({
        'url': VATURL+$(s.inputCountry).val()+$(input).val(),
        'method': "GET",
        "headers": {"Authorization": "Bearer "+TOKEN},
        success: function(data){
          if (data.data.some(item => item.valid)) {
            $(input).removeClass('is-error');
            $(error).text('');
            submitForm();
          } else {
            Swal.close();
            $(input).addClass('is-error');
            $(error).text(invoice_errors.vat);
          }
        },
        error: function(e){
          console.log(e);
          Swal.close();
          $(input).addClass('is-error');
          $(error).text(invoice_errors.vat);
        }
      });
    } else {
      submitForm();
    }
  }

  function submitForm(){
    var d = new FormData($(s.form).get(0));
    var items = parseInt($(s.form).attr('data-cart-items'));
    $.ajax({
      url: $(s.form).attr('action'),
      method: "POST",
      accept: "*/*",
      contentType: "application/json",
      data: JSON.stringify({
        "isCompany": true,
        "billingCountry": d.get('billingCountry'),
        "companyName": d.get('companyName'),
        "vatNumber": d.get('vatNumber'),
        "pec": d.get('pec'),
        "sdiCode": d.get('sdiCode'),
      }),
      success: function(data){
        setTimeout(function(){
          if(items > 0){
            Swal.fire({
              title: success_msg.title,
              html: success_msg.description,
              confirmButtonText: success_msg.checkout,
              cancelButtonText: success_msg.account,
              showCancelButton: true,
              icon: 'success',
            }).then(function(r){
              if(r.isConfirmed)
                location.href = Shopify.routes.root+"cart";
              else
                location.href = Shopify.routes.root+'account';
            });
          } else {
            Swal.fire({
              title: success_msg.title,
              html: success_msg.description,
              confirmButtonText: success_msg.account,
              icon: 'success',
            }).then(function(){
              location.href = Shopify.routes.root+'account';
            });
          }
        }, 5000);
      },
      error: function(error){
        Swal.close();
        console.log(error);
      }
    });
  }

  function setUppercase(input){
    $(input).val($(input).val().toUpperCase());
  }
}

function registerForm(){
  var checkVat = false;
  var checkPec = false;
  var checkCompany = false;
  const eu = ['AT', 'BE', 'BG', 'CY', 'HR', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'IE', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'CZ', 'RO', 'SK', 'SI', 'ES', 'SE', 'HU', 'IT'];

  const s = {
    inputFirstname: '#register-form #register-firstname',
    inputLastname: '#register-form #register-lastname',
    inputEmail: '#register-form #register-email',
    inputPassword: '#register-form #register-password',
    inputCountry: '#register-form #register-country',
    inputCompany: '#register-form #register-company',
    inputVat: '#register-form #register-vat',
    inputPec: '#register-form #register-pec',
    inputSdi: '#register-form #register-sdi',
    inputCheck: '#register-form #register-c',
    inputs: '#register-form [data-invoice-input]',
    sdiPec: '#register-form [data-optional]',
    request: '#register-form [data-register-company]',
    submit: '#register-form #register-submit',
    form: '#register-form'
  }
  checkData();

  $(s.submit).on('click', function(){
    checkData();
    var validCompany = validateCompany();
    var validVat = validateVat();
    var validPec = validatePec();
    var validSdi = validateSdi();
    var validFirstname = validateFirstname();
    var validLastname = validateLastname();
    var validEmail = validateEmail();
    var validPassword = validatePassword();
    if(validCompany && validVat && validPec && validSdi && validFirstname && validLastname && validEmail && validPassword){
      controlVat();
    }
  });

  $(s.inputCountry).on('change', function(){
    checkCountry();
  });

  $(s.inputSdi).on('blur', function(){
    setUppercase(this);
  });

  $(s.inputCheck).on('change', function(){
    checkData();
  });

  $(s.inputs).on('focus', function(){
    var error = $(this).parent().find('[data-error]');
    // For password field with input-group wrapper, go up one more level
    if(error.length === 0 && this.id === 'register-password'){
      error = $(this).parent().parent().find('[data-error]');
    }
    $(this).removeClass('is-error');
    $(error).text('');
  });
  $(s.inputSdi).on('keyup', function(){
    disableInput();
  });

  $(s.inputPec).on('keyup', function(){
    disableInput();
  });

  function disableInput() {
    if($(s.inputPec).val().length > 0){
      $(s.inputSdi).prop('disabled', true);
      $(s.inputSdi).val('');
      $(s.inputPec).prop('disabled', false);
    } else if($(s.inputSdi).val().length > 0){
      $(s.inputSdi).prop('disabled', false);
      $(s.inputPec).val('');
      $(s.inputPec).prop('disabled', true);
    } else {
      $(s.inputSdi).prop('disabled', false);
      $(s.inputPec).prop('disabled', false);
    }
  }

  function validateFirstname(){
    var input = s.inputFirstname;
    var val = $(input).val();
    var error = $(input).parent().find('[data-error]');
    var valid = val != undefined && val.length > 0;
    if(valid){
      $(input).removeClass('is-error');
      $(error).text('');
    } else {
      $(input).addClass('is-error');
      $(error).text(invoice_errors.required);
    }
    return valid;
  }

  function validateLastname(){
    var input = s.inputLastname;
    var val = $(input).val();
    var error = $(input).parent().find('[data-error]');
    var valid = val != undefined && val.length > 0;
    if(valid){
      $(input).removeClass('is-error');
      $(error).text('');
    } else {
      $(input).addClass('is-error');
      $(error).text(invoice_errors.required);
    }
    return valid;
  }

  function validateEmail(){
    var input = s.inputEmail;
    var val = $(input).val();
    var error = $(input).parent().find('[data-error]');
    var valid = val != undefined && val.length > 0;
    var msg = invoice_errors.required;
    if(valid && checkPec){
      valid = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(val);
      msg = invoice_errors.email;
    }
    if(valid){
      $(input).removeClass('is-error');
      $(error).text('');
    } else {
      $(input).addClass('is-error');
      $(error).text(msg);
    }
    return valid;
  }

  function validatePassword(){
    var input = s.inputPassword;
    var val = $(input).val();
    var error = $(input).parent().parent().find("[data-error]");
    var valid = val != undefined && val.length > 0;
    if(valid){
      $(input).removeClass('is-error');
      $(error).text('');
    } else {
      $(input).addClass('is-error');
      $(error).text(invoice_errors.required);
    }
    return valid;
  }

  function validateCompany(){
    var valid = true;
    if(checkCompany){
      var input = s.inputCompany;
      var val = $(input).val();
      var error = $(input).parent().find('[data-error]');
      valid = val != undefined && val.length > 0;
      if(valid){
        $(input).removeClass('is-error');
        $(error).text('');
      } else {
        $(input).addClass('is-error');
        $(error).text(invoice_errors.required);
      }
    }
    return valid;
  }

  function validateVat(){
    var valid = true;
    if(checkVat){
      var input = s.inputVat;
      var val = $(input).val();
      var error = $(input).parent().find('[data-error]');
      valid = val != undefined && val.length > 0;
      if(valid){
        var r = VATS[$(s.inputCountry).val()];
        if(r != undefined){
          valid = r.test(val);
          if(valid){
            $(input).removeClass('is-error');
            $(error).text('');
          } else {
            $(input).addClass('is-error');
            $(error).text(invoice_errors.vat);
          }
        }
      } else {
        $(input).addClass('is-error');
        $(error).text(invoice_errors.required);
      }
    }
    return valid;
  }

  function validatePec(){
    var valid = true;
    if(checkCompany){
      var input = s.inputPec;
      var val = $(input).val();
      var sdi = $(s.inputSdi).val();
      var error = $(input).parent().find('[data-error]');
      var msg = invoice_errors.required_pec;
      valid = false;
      if(checkPec){
        if(val != undefined && val.length > 0){
          valid = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(val);
          msg = invoice_errors.email;
        } else if(sdi != undefined && sdi.length > 0){
          valid = true;
        } 
      } else {
        valid = true;
      }
      if(valid){
        $(input).removeClass('is-error');
        $(error).text('');
      } else {
        $(input).addClass('is-error');
        $(error).text(msg);
      }
    }
    return valid;
  }

  function validateSdi(){
    var valid = true;
    if(checkCompany){
      var input = s.inputSdi;
      var val = $(input).val();
      var pec = $(s.inputPec).val();
      var error = $(input).parent().find('[data-error]');
      var msg = invoice_errors.required_pec;
      valid = false;
      console.log(checkPec);
      if(checkPec){
        if(val != undefined && val.length > 0){
          valid = /^[0-9a-zA-Z]{7}$/gm.test(val);
          msg = invoice_errors.sdi;
        } else if(pec != undefined && pec.length > 0){
          valid = true;
        }
      } else {
        valid = true;
      }
      if(valid){
        $(input).removeClass('is-error');
        $(error).text('');
      } else {
        $(input).addClass('is-error');
        $(error).text(msg);
      }
    }
    return valid;
  }

  function checkCountry(){
    if(checkCompany){
      var country = $(s.inputCountry).val();
      
      if(country == 'IT'){
        checkPec = true;
      } else {
        checkPec = false;
      }
  
      if(eu.indexOf(country) != -1){
        checkVat = true;
      } else {
        checkVat = false;
      }
  
      if(checkPec){
        $(s.sdiPec).removeClass('hide');
      } else {
        $(s.sdiPec).addClass('hide');
      }
      console.log(checkPec);
    }
  }

  function checkData(){
    if($(s.inputCheck).is(':checked')){
      checkCompany = true;
    } else {
      checkCompany = false;
      checkPec = false;
      checkVat = false;
    }

    if(checkCompany){
      $(s.request).removeClass('hide');
    } else {
      $(s.request).addClass('hide');
    }
    checkCountry();
  }

  function controlVat(){
    if(checkVat){
      var input = s.inputVat;
      var error = $(input).parent().find('[data-error]');
      $.ajax({
        'url': VATURL+$(s.inputCountry).val()+$(input).val(),
        'method': "GET",
        "headers": {"Authorization": "Bearer "+TOKEN},
        success: function(data){
          if (data.data.some(item => item.valid)) {
            $(input).removeClass('is-error');
            $(error).text('');
            submitForm();
          } else {
            Swal.close();
            $(input).addClass('is-error');
            $(error).text(invoice_errors.vat);
          }
        },
        error: function(e){
          console.log(e);
          $(input).addClass('is-error');
          $(error).text(invoice_errors.vat);
        }
      });
    } else {
      submitForm();
    }
  }

  function submitForm(){
    $('#register-form').trigger('submit');
  }

  function setUppercase(input){
    $(input).val($(input).val().toUpperCase());
  }
}

function viewMore(){
  $('[data-maxheight]').each(function(){
    var maxheight = parseInt($(this).attr('data-maxheight'));
    var height = $(this).get(0).clientHeight;
    if(height >= maxheight){
      $(this).parent().find('[data-btn-view]').css('display', 'block');
    }
  });

  $('[data-btn-view]').on('click', function(e){
    e.preventDefault();
    $(this).parent().find('[data-maxheight]').addClass('open');
    $(this).css('display', 'none');
    $(this).parent().find('[data-btn-less]').css('display', 'block');
  });

  $('[data-btn-less]').on('click', function(e){
    e.preventDefault();
    $(this).parent().find('[data-maxheight]').removeClass('open');
    $(this).css('display', 'none');
    $(this).parent().find('[data-btn-view]').css('display', 'block');
  });
}

function menu(){
  $('.nav-container [aria-controls]').on('mouseover', function(){
    var id = '#'+$(this).attr('aria-controls');
    $('.menu-container').attr('aria-expanded', false);
    $('.menu-container').removeAttr('open');
    $(id).attr('aria-expanded', true);
    $(id).attr('open', true);
  });
  $('.menu-container').on('mouseleave', function(){
    $(this).attr('aria-expanded', false);
    $(this).removeAttr('open');
  });

}

function passwordHide(){
  $('[data-password-btn]').on('click', function(){
    var p = $(this).parents('[data-password-parent]').toggleClass('show');
    var input = $(p).find('input');
    if($(p).hasClass('show')){
      $(input).attr('type', 'text');
    } else {
      $(input).attr('type', 'password');
    }
  });
}

function drawer(){
  //all'evento sul document cart:quantity devo sostituire il contenuto dei div con classe cart__footer facendo una chiamata ajax al location.href che conterrà un altro div con classe cart__footer. devo sostituire il contenuto di cart__footer con il contenuto del div ottenuto dalla chiamata ajax

  document.addEventListener('cart:updated', function(e){
    updateTotals(); 
  });
  document.addEventListener('ajaxProduct:added', function(e){
    updateTotals(); 
  });
}

function updateTotals() {
  var url = location.href;
  var footer = document.querySelector('.cart__footer');
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url);

  xhr.onreadystatechange = function(){
    if(xhr.readyState == 4 && xhr.status == 200){
      var div = document.createElement('div');
      div.innerHTML = xhr.responseText;
      var newFooter = div.querySelector('.cart__footer');
      footer.innerHTML = newFooter.innerHTML;

      //bisogna fare lo stesso anche per i div con classe cart__item-sub
      var items = document.querySelectorAll('.cart__item--subtotal');
      var newItems = div.querySelectorAll('.cart__item--subtotal');
      for(var i=0;i<items.length;i++){
        items[i].innerHTML = newItems[i].innerHTML;
      }

      var freeshippings = document.querySelectorAll('.free-shipping');
      var newFreeshippings = div.querySelectorAll('.free-shipping');
      for(var i=0;i<freeshippings.length;i++){
        freeshippings[i].innerHTML = newFreeshippings[i].innerHTML;
      }
    }
  };
  xhr.send();
}

function buildQuery(obj) {
  var Result= '';
  if(typeof(obj)== 'object') {
      jQuery.each(obj, function(key, value) {
          Result+= (Result) ? '&' : '';
          if(typeof(value)== 'object' && value.length) {
              for(var i=0; i<value.length; i++) {
                  Result+= [key+'[]', encodeURIComponent(value[i])].join('=');
              }
          } else {
              Result+= [key, encodeURIComponent(value)].join('=');
          }
      });
  }
  return Result;
}

class ElementMover extends HTMLElement{
	constructor(){
		super();
	}

	connectedCallback() {
    this.tenant = this.parentElement.querySelector(this.dataset.target);
    this.newHome = document.querySelector(`.new-home[data-tenant='${this.dataset.target}']`);
    if(this.tenant && this.newHome && window.matchMedia('(max-width: 768px)').matches){
      this.newHome.parentElement.insertBefore(this.tenant, this.newHome);
    }
    this.newHome.remove();
    this.remove();
	}
}
if(!window.customElements.get('element-mover')){
	window.customElements.define('element-mover', ElementMover);
}
